import { defineSlotRecipe } from '@chakra-ui/react';
import { Space, Colors, TextStyles, BorderWidths, Radii, FontSizes, Shadows } from '../../types';

export const popoverSlotRecipe = defineSlotRecipe({
  slots: [
    'root',
    'trigger',
    'positioner',
    'content',
    'title',
    'header',
    'body',
    'footer',
    'arrow',
    'arrowTip',
    'closeTrigger',
  ],
  base: {
    positioner: {
      zIndex: 'tooltip',
    },
    content: {
      '--popper-bg': `colors.${Colors.SURFACE_ELEVATED}`,
      '--popper-border': `colors.${Colors.BORDER_DEFAULT}`,
      '--close-button-size': `spacing.${Space.SPACE_6}`,
      '--popper-arrow-size': `spacing.${Space.SPACE_3}`,
      '--popper-arrow-bg': 'var(--popper-bg)',
      '--popper-arrow-shadow-color': 'var(--popper-border)',
      border: 'none',
      bg: 'var(--popper-bg)',
      maxW: 'xs',
      borderRadius: Radii.XL,
      boxShadow: Shadows.LG,
      zIndex: 'inherit',
      _focusVisible: {
        outline: 0,
        boxShadow: Shadows.LG,
      },
      _dark: {
        border: '1px solid var(--popper-border)',
        '--popper-border': `colors.${Colors.SURFACE_DIALOG}`,
        '--popper-arrow-shadow-color': 'var(--popper-border)',
        '--popper-bg': `colors.${Colors.SURFACE_ELEVATED}`,
        '--popper-arrow-bg': 'var(--popper-bg)',
      },
    },
    header: {
      px: Space.SM,
      pt: Space.SM,
      pb: Space.XS,
      borderBottomWidth: BorderWidths.XS,
      borderBottomColor: Colors.BORDER_ELEVATED,
      textStyle: TextStyles.H4,
      color: Colors.TEXT_EMPHASIS,
    },
    body: {
      p: Space.SM,
      textStyle: TextStyles.P2,
      color: Colors.TEXT_MUTED,
    },
    footer: {
      px: Space.SM,
      py: Space.XS,
      borderTopColor: Colors.BORDER_ELEVATED,
      borderBottomRadius: Radii.LG,
    },
    closeTrigger: {
      position: 'absolute',
      insetBlockStart: Space.XS,
      insetInlineEnd: Space.XS,
      borderRadius: Radii.SM,
      padding: Space.SPACE_0_5,
      fontSize: FontSizes['2XS'],
      h: 'var(--close-button-size)',
      w: 'var(--close-button-size)',
      color: Colors.ICON_DEFAULT,
      _hover: {
        color: Colors.ICON_HOVER,
        bg: Colors.SURFACE_TERTIARY_HOVER,
      },
      _active: {
        color: Colors.ICON_ACTIVE,
        bg: Colors.SURFACE_TERTIARY_ACTIVE,
      },
    },
  },
});
